import axios from "./axios"; // Import the centralized Axios instance

const state = {
  purchase_orders: [],
};

const getters = {
  allPurchaseOrders: (state) => state.purchase_orders,
};

const actions = {
  async fetchPurchaseOrders({ commit }) {
    try {
      commit("resetPurchaseOrders");
      const response = await axios.get("/purchase-order", { params: { page: 1, limit: 25 } });
      commit("setPurchaseOrders", response.data);
    } catch (error) {
      console.error("Failed to fetch purchase_orders:", error);
    }
  },
  async createPurchaseOrder({ commit }, purchase_order) {
    try {
      const response = await axios.post("/purchase-order", purchase_order);
      commit("addPurchaseOrder", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create purchase_order:", error);
      throw error;
    }
  },
  async fetchPurchaseOrderById(_, id) {
    try {
      const response = await axios.get(`/purchase-order/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch purchase_order:", error);
      throw error;
    }
  },
  async updatePurchaseOrder({ commit }, purchase_order) {
    try {
      const response = await axios.put(`/purchase-order/${purchase_order.id}`, purchase_order);
      commit("updatePurchaseOrder", response.data);
    } catch (error) {
      console.error("Failed to update purchase_order:", error);
      throw error;
    }
  },
  async deletePurchaseOrderById({ commit }, id) {
    try {
      const response = await axios.delete(`/purchase-order/${id}`);
      commit("removePurchaseOrder", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete purchase_order:", error);
      throw error;
    }
  },
};

const mutations = {
  setPurchaseOrders(state, purchase_orders) {
    state.purchase_orders = purchase_orders.data; // Ensure this matches your API's response structure
  },
  addPurchaseOrder(state, purchase_order) {
    state.purchase_orders.push(purchase_order);
  },
  updatePurchaseOrder(state, updatedPurchaseOrder) {
    const index = state.purchase_orders.findIndex(
      (purchase_order) => purchase_order.id === updatedPurchaseOrder.id
    );
    if (index !== -1) {
      state.purchase_orders.splice(index, 1, updatedPurchaseOrder);
    }
  },
  removePurchaseOrder(state, id) {
    state.purchase_orders = state.purchase_orders.filter(
      (purchase_order) => purchase_order.id !== id
    );
  },
  resetPurchaseOrders(state) {
    state.purchase_orders = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
